__turbopack_context__.v({
  "close": "_4Ofv1G_close",
  "overlay": "_4Ofv1G_overlay",
  "overlay--close": "_4Ofv1G_overlay--close",
  "overlay--open": "_4Ofv1G_overlay--open",
  "scroll-lock": "_4Ofv1G_scroll-lock",
  "submit": "_4Ofv1G_submit",
  "title": "_4Ofv1G_title",
  "wrapper": "_4Ofv1G_wrapper",
  "wrapper--close": "_4Ofv1G_wrapper--close",
  "wrapper--open": "_4Ofv1G_wrapper--open",
});
